import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { EyeIcon } from "@heroicons/react/24/outline";
import { Container, PageHeader, RowAction, Table, Tag } from "../ui";
import { formatKigaliDate } from "../scholarships/model";
import { callPhaseOf, useAbroadCalls } from "./model";
import { callReviewPath } from "./review";

const PAGE_SIZE = 20;

// The published abroad loan calls, each opening its applications, scores and award list
export default function ReviewCallsPage() {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const { data, isPending, isError } = useAbroadCalls({ state: "PUBLISHED", page, size: PAGE_SIZE });
  const open = (call) => navigate(callReviewPath(call.id));

  const columns = [
    { key: "name", label: "Loan call", render: (c) => <span className="font-medium text-slate-800">{c.name}</span> },
    { key: "opensAt", label: "Opens", accessor: (c) => formatKigaliDate(c.opensAt) },
    { key: "closesAt", label: "Closes", accessor: (c) => formatKigaliDate(c.closesAt), sortValue: (c) => c.closesAt },
    { key: "programmeCount", label: "Programmes" },
    { key: "state", label: "State", accessor: (c) => callPhaseOf(c).label, render: (c) => <Tag color={callPhaseOf(c).color}>{callPhaseOf(c).label}</Tag> },
    { key: "open", label: "", exportable: false, render: (c) => <RowAction Icon={EyeIcon} label="Applicants" onClick={() => open(c)} /> },
  ];

  return (
    <Container className="flex flex-col gap-6 py-6">
      <PageHeader title="Abroad loan applicants" subtitle="Scores and the award list of each published loan call" />
      <Table cardView
        columns={columns}
        data={data?.items ?? []}
        onRowClick={open}
        isLoading={isPending}
        searchable={false}
        exportName="abroad-loan-reviews"
        emptyTitle={isError ? "Could not load the loan calls. Please try again later." : "No published loan calls"}
        pagination={{ page, totalPages: data ? Math.ceil(data.total / PAGE_SIZE) : 0, totalElements: data?.total, pageSize: PAGE_SIZE, onPageChange: setPage }}
      />
    </Container>
  );
}
